import sweeetalert from "sweetalert2";

const sweeetalertWithLines = props => {
  if (props.text && !props.html) {
    const { text, ...otherProps } = props;
    const textString = text.toString();
    const textWithLineBrs = textString.replace(/\n/g, "<br />");
    if (textWithLineBrs !== textString) {
      return sweeetalert({
        ...otherProps,
        html: textWithLineBrs
      });
    }
  }
  return sweeetalert(props);
};

const error = (text = "Algo deu errado...") => {
  if (text instanceof Error) {
    text = text.message;
  }
  return sweeetalertWithLines({
    type: "error",
    text
  });
};

const success = (title = "Sucesso!", text = "Solicitação processada.") => {
  return sweeetalertWithLines({
    title,
    type: "success",
    text
  });
};

const warning = (title = "Atenção!", text = "Solicitação processada.") => {
  return sweeetalertWithLines({
    title,
    type: "warning",
    text
  });
};

const toast = (text = "Erro!", error = true) => {
  return sweeetalert({
    type: error ? "error" : "success",
    text,
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000
  });
};

const modal = props => {
  return sweeetalert(props);
};

const confirmModal = (props = {}) => {
  const {
    title = "Tem certeza?",
    text = "Deseja prosseguir com sua solicitação?",
    cancelButtonText = 'Cancelar',
    ...otherProps
  } = props;
  return sweeetalert({
    ...otherProps,
    title,
    text,
    type: "info",
    cancelButtonText: cancelButtonText,
    confirmButtonText: "Sim",
    showCancelButton: true
  });
};

const confirmModalHasCpnj = (props = {}) => {
  const {
    title = "Tem certeza?",
    text = "Deseja prosseguir com sua solicitação?",
    ...otherProps
  } = props;
  return sweeetalert({
    ...otherProps,
    title,
    text,
    type: "info",
    cancelButtonText: "Cancelar",
    confirmButtonText: "aceitar",
    showCancelButton: true
  });
};

const noWait = {
  error: (...params) => {
    error(...params);
  },
  confirmModal: (...params) => {
    confirmModal(...params);
  },
  success: (...params) => {
    success(...params);
  },
  toast: (...params) => {
    toast(...params);
  },
  modal: (...params) => {
    modal(...params);
  }
};

export const swal = {
  error,
  confirmModal,
  success,
  toast,
  modal,
  noWait,
  warning,
  confirmModalHasCpnj
};
